import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock, ShieldCheck } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="py-20 px-4 bg-gradient-to-b from-brand-bg to-[#0a0a0a]" data-id="element-135">
      <div className="max-w-3xl mx-auto text-center" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-surface border-2 border-brand-yellow rounded-2xl p-8 md:p-12 shadow-[0_0_50px_rgba(234,179,8,0.15)] relative overflow-hidden" data-id="element-137">
          {/* Badge */}
          <div className="absolute top-0 right-0 bg-brand-yellow text-black font-bold text-xs uppercase px-3 py-1 rounded-bl-lg" data-id="element-138">
            Oferta Limitada
          </div>

          <h2 className="font-display text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-139">
            Empieza Tu Plan de 7 Días
          </h2>
          <p className="text-gray-400 mb-8 max-w-lg mx-auto" data-id="element-140">
            Si este Libro Digital te evita perder 3 semanas "pensando" y te
            ayuda a conseguir 1 solo cliente, ya se pagó solo.
          </p>

          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-141">
            <span className="text-gray-500 line-through text-2xl" data-id="element-142">$97</span>
            <span className="text-6xl font-display font-bold text-brand-yellow" data-id="element-143">
              $7.26
            </span>
            <span className="text-gray-400 text-xl self-end mb-2" data-id="element-144">USD</span>
          </div>

          <a href="https://www.mellowreset.com/cart/42978888450114:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof window.fbq === 'function') {
            window.fbq('track', 'InitiateCheckout');
          }
        }} className="w-full md:w-auto bg-brand-yellow hover:bg-brand-yellowHover text-black font-display font-bold text-2xl uppercase py-5 px-10 rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3 mx-auto mb-6" data-id="element-145">
            Descargar Ahora
            <ArrowRight className="w-6 h-6" strokeWidth={3} data-id="element-146" />
          </a>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-500" data-id="element-147">
            <div className="flex items-center gap-2" data-id="element-148">
              <Lock size={14} data-id="element-149" /> Pago Seguro 256-bit SSL
            </div>
            <div className="hidden md:block" data-id="element-150">•</div>
            <div className="flex items-center gap-2" data-id="element-151">
              <ShieldCheck size={14} data-id="element-152" /> Garantía de Calidad
            </div>
            <div className="hidden md:block" data-id="element-153">•</div>
            <div data-id="element-154">Acceso Inmediato</div>
          </div>
        </motion.div>

        <div className="mt-12 text-gray-500 text-sm max-w-xl mx-auto" data-id="element-155">
          <p className="mb-4" data-id="element-156">
            Este producto no garantiza ingresos específicos. Los resultados
            dependen de tu ejecución. No estamos afiliados con Facebook,
            Instagram o WhatsApp.
          </p>
          <p data-id="element-157">
            © {new Date().getFullYear()} Tu Primer Ingreso Extra. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </section>;
}